import { render } from "./CrudOfflineOnline.vue?vue&type=template&id=6582b9b7"
import script from "./CrudOfflineOnline.vue?vue&type=script&lang=js"
export * from "./CrudOfflineOnline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__